import React from 'react';
import UserLayout from '../../../../components/user-layout/UserLayout';

import styles from './jobsMgmt.module.scss';

const JobsMgmt = () => {
  return (
    <UserLayout>
      <div>JobsMgmt</div>
    </UserLayout>
  );
};

export default JobsMgmt;
